import { createSelector, createSlice } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory, queryMapFactory } from '../common/reducers/utilities';
import { ensureArray } from '../common/utils/arrayUtilities';

const publicFormSlice = createSlice({
    name: 'publicForm',
    initialState: {
        data: {}
    },
    reducers: {
        set: (state, action) => {
            state.data = {};
            ensureArray(action.payload).forEach(form => state.data[form.code] = form);
        },
        setSingle: (state, action) => {
            state.data[action.payload.code] = action.payload;
        },
        addOrUpdate: (state, action) => {
            for (const form of ensureArray(action.payload)) {
                state.data[form.code] = form;
            }
        },
        remove: (state, action) => {
            for (const form of ensureArray(action.payload)) {
                delete state.data[form.code];
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => publicFormSlice.getInitialState());
    }
});

// #region network operations
const fetchPublicForms = network => network.get('/api/v1/publicforms', publicFormSlice.actions.set);
const fetchForm = code => network => {
    return network.get('/api/v1/publicform/' + encodeURIComponent(code), data => publicFormSlice.actions.setSingle({ ...data, code }))
}
export const submitPublicForm = (network, code, form, jobid) => network.put('/api/v1/submitform/' + encodeURIComponent(code) + (jobid ? '?=jobid=' + encodeURIComponent(jobid) : ''), form)
// #endregion

// #region selectors
const selectPublicFormData = state => state.publicForm.data;
const selectPublicForms = createSelector([selectPublicFormData], formMap => Object.values(formMap));
const createSelectPublicForm = createSelector([selectPublicFormData, (state, code) => code], (formMap, code) => formMap[code]);
const selectPublicForm = code => state => createSelectPublicForm(state, code);
// #endregion

// #region listeners
const registerFormListeners = (register, dispatch, network, credentials) => {
    const cleanup = [
    ];
    return () => cleanup.forEach(c => c());
}
// #endregion

const initByID = initMapFactory(fetchForm, registerFormListeners, { authenticated: false });
export const [usePublicForms] = dataHookFactory(selectPublicForms, queryMapFactory(fetchPublicForms, 'code', initByID, registerFormListeners));
export const [usePublicForm] = dataHookFactory(selectPublicForm, initByID);

const reducerDetails = { name: publicFormSlice.name, reducer: publicFormSlice.reducer };
export default reducerDetails;